import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Promotion } from '@/models';
import { AccountPageLoadEvent } from '@/services/analytics/events';
import { AnalyticsEventAction, AnalyticsEventCategory, AnalyticsEventLabel } from '@/services/google/google-analytics.services';

@Component({
  name: 'CmgOffers',
})
export default class CmgOffers extends Vue {
  shouldShowFloatingTracker = true;

  async mounted(): Promise<void> {
    const isLoggedIn = await this.$services.customer.waitForCustomerInitialization();
    if (!isLoggedIn) {
      window.location.replace(`${window.location.origin}/offers`);
      return;
    }

    if (!this.$appStore.state.customer.newAccount) {
      try {
        await this.$services.promotions.refreshCustomerPromotions();
      } catch (e: any) {
        this.$services.logger.error('Something went wrong while fetching customer promotions: ', e);
      }
    }    

    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.OffersLanding,
      action: AnalyticsEventAction.PageViewed,
      label: AnalyticsEventLabel.OffersPageViewed,
    });
  }

  get isLoggedIn(): boolean {
    return this.$services.customer.isLoggedIn() === true;
  }

  get loading(): boolean {
    this.$services.ui.nextFocus('point-rewards');
    const loading = !this.isCustomerInitialized;
    this.$services.ui.setAppBlur(loading);
    this.$services.ui.setAppPepperVisibility(loading);
    return loading;
  }

  get isCustomerInitialized(): boolean {
    return this.$services.customer.isLoggedIn() !== undefined;
  }

  get promotions(): Promotion[] {
    return this.$appStore.state.customer.wallet.promotions;
  }

  get promoItems() {
    let { promotions } = this.$appStore.state.customer.wallet;

    return promotions;
  }

  get offersCount() {
    return this.$appStore.state.customer.wallet.promotions.length;
  }

  get offersTitle() {
    return this.offersCount > 0 ? `MY OFFERS (${this.offersCount})` : 'MY OFFERS';
  }

  onClickAddOffer(event:any) {
    this.$services.googleAnalytics.sendCustomEvent({
        category: AnalyticsEventCategory.OffersLanding,
        action: AnalyticsEventAction.AddOfferClick,
        label: AnalyticsEventLabel.AddOfferClick,
    });

    this.$services.ui.pushEventTargetAsLastSelectedElement(event);
    this.$services.ui.setModalVisibility('addReward', true);
    this.$services.analytics.send(new AccountPageLoadEvent('offers-add-offers'));
    this.$services.ui.firstFocus();
  }  
}
